import type { z } from "zod";

import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  CafesRestaurantsBadgeTypesDtoSchema,
  CafesRestaurantsPageDtoSchema,
  CafesRestaurantsPointDtoSchema,
  type CafesRestaurantsPointSchema,
  CafesRestaurantsTypesDtoSchema,
} from "./schemas";
import type {
  CafesRestaurantsBadgeType,
  CafesRestaurantsPageType,
  CafesRestaurantsPoints,
  CafesRestaurantsType,
} from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToCafesRestaurantsPage = (
  dto: unknown,
): CafesRestaurantsPageType => {
  const parsed = safeParseWithFallback(
    CafesRestaurantsPageDtoSchema,
    dto,
    "mapDtoToCafesRestaurantsPage",
  );

  return extractData(parsed, dto, dto as CafesRestaurantsPageType);
};

export const mapDtoToCafesRestaurantsPoints = (
  dto: unknown,
): CafesRestaurantsPoints => {
  const parsed = safeParseWithFallback(
    CafesRestaurantsPointDtoSchema,
    dto,
    "mapDtoToCafesRestaurantsPoints",
  );

  const rawData = extractDataWithMeta<
    z.infer<typeof CafesRestaurantsPointSchema>[],
    CafesRestaurantsPoints["meta"]
  >(parsed, dto, defaultMeta as CafesRestaurantsPoints["meta"]);

  return {
    data: rawData.data,
    meta: rawData.meta,
  };
};

export const mapDtoToCafesRestaurantsTypes = (
  dto: unknown,
): CafesRestaurantsType[] => {
  const parsed = safeParseWithFallback(
    CafesRestaurantsTypesDtoSchema,
    dto,
    "mapDtoToCafesRestaurantsTypes",
  );

  return extractData(parsed, dto, []);
};

export const mapDtoToCafesRestaurantsBadgeTypes = (
  dto: unknown,
): CafesRestaurantsBadgeType[] => {
  const parsed = safeParseWithFallback(
    CafesRestaurantsBadgeTypesDtoSchema,
    dto,
    "mapDtoToCafesRestaurantsBadgeTypes",
  );

  return extractData(parsed, dto, []);
};
